<script>
import Modal from '@phoenix/mixins/components/common/Modal';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  mixins: [Modal],
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="modal__overlay" tabindex="-1">
      <div class="modal__container" role="dialog" aria-modal="true" :aria-labelledby="`${id}-title`" :data-cy="dataCy">
        <header :class="_headerClasses">
          <div :id="`${id}-title`" class="modal__title h5">{{ title }}</div>

          <phxsg-button
            size="sm"
            icon-only
            icon-id="close"
            :data-modal-close="id"
            :label="$t('Accessibility.modal.close')"
          />
        </header>

        <slot name="header" />

        <main :id="`${id}-content`" :class="_contentClasses">
          <slot name="content" />
        </main>

        <footer v-if="hasFooterSlot" class="modal__footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>
